module.exports = __webpack_public_path__ + "static/img/sw_qw_4.8f9973db.png";